// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Unit system selector dropdown */

.dropdown {
  position: relative;
  flex-shrink: 0;
}

.dropdown-toggle {
  font-size: 0.9rem;
  height: 100%;
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  gap: 1px;
  align-items: center;
  padding: 0;
}

.dropdown-icon {
  display: flex;
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 100px;
  margin: 0;
  padding: 6px 0;
  list-style: none;
  background: rgba(20, 20, 20, 0.9);
  border-radius: 10px;
  display: none;
}

.dropdown-menu li {
  padding: 8px 12px;
  cursor: pointer;
  color: #fff;
}

.dropdown-menu li:hover {
  background: rgba(255, 255, 255, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/styles/utilities/customDropdown.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* Unit system selector dropdown */\n\n.dropdown {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.dropdown-toggle {\n  font-size: 0.9rem;\n  height: 100%;\n  background: transparent;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  border-radius: 8px;\n  display: flex;\n  gap: 1px;\n  align-items: center;\n  padding: 0;\n}\n\n.dropdown-icon {\n  display: flex;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  min-width: 100px;\n  margin: 0;\n  padding: 6px 0;\n  list-style: none;\n  background: rgba(20, 20, 20, 0.9);\n  border-radius: 10px;\n  display: none;\n}\n\n.dropdown-menu li {\n  padding: 8px 12px;\n  cursor: pointer;\n  color: #fff;\n}\n\n.dropdown-menu li:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
